import VueFlatPickr from 'vue-flatpickr-component'

flatpickr.setDefaults({
  altInput: true,
  altFormat: 'm/d/Y',
})

export default VueFlatPickr
